module.exports = __webpack_public_path__ + "img/portugal.7694fa56.svg";